import styled from "styled-components";
import { HashLink } from "react-router-hash-link";

export const StyledAnchorLink = styled(HashLink)`
    display: block;
    background: rgb(227, 129, 70);
    border-radius: 45px;
    border: unset;
    outline: none;
    font-weight: 600;
    color: rgb(249, 241, 221);
    font-size: 28px;
    max-width: 320px;
    height: 87px;
    line-height: 87px;
    text-align: center;
    width: 100%;
    text-decoration: unset;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
    @media (max-width: 1199px) {
        font-size: calc(16px + (12) * ((100vw - 320px) / (1200 - 320)));
        max-width: calc(150px + (170) * ((100vw - 320px) / (1200 - 320)));
        height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
        line-height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 599px) {
        margin: auto;
        font-size: 20px;
        max-width: calc(100vw - 30px);
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const StyledButton = styled.button`
    display: block;
    background: rgb(227, 129, 70);
    border-radius: 45px;
    border: unset;
    outline: none;
    font-weight: 600;
    color: rgb(249, 241, 221);
    font-size: 28px;
    max-width: 320px;
    height: 87px;
    line-height: 87px;
    text-align: center;
    width: 100%;
    text-decoration: unset;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
    @media (max-width: 1199px) {
        font-size: calc(16px + (12) * ((100vw - 320px) / (1200 - 320)));
        max-width: calc(150px + (170) * ((100vw - 320px) / (1200 - 320)));
        height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
        line-height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 599px) {
        margin: auto;
        font-size: 20px;
        max-width: calc(100vw - 100px);
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const DefaultButton = styled.a`
    display: block;
    background: rgb(227, 129, 70);
    border-radius: 45px;
    border: unset;
    outline: none;
    font-weight: 600;
    color: rgb(249, 241, 221);
    font-size: 28px;
    max-width: 320px;
    height: 87px;
    line-height: 87px;
    text-align: center;
    width: 100%;
    text-decoration: unset;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
    @media (max-width: 1199px) {
        font-size: calc(16px + (12) * ((100vw - 320px) / (1200 - 320)));
        max-width: calc(150px + (170) * ((100vw - 320px) / (1200 - 320)));
        height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
        line-height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 599px) {
        margin: auto;
        font-size: 20px;
        max-width: calc(100vw - 100px);
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
